import axios from "./axios";
import { apiUrl, eventBase } from "../config/crud";
import { PUBLIC_FACE_SEARCH_EVENTS } from "../utils/constants";

const API_URL = apiUrl;
const EVENT = eventBase;

// Get list of gallery categories
export const getCategoryIds = (eventId: string) => {
	const QUERY = `?category_type=4`;
	return axios.get(`${API_URL}/${EVENT}/${eventId}/category${QUERY}`);
};

export const UploadFile = (file: any) => {
	return axios.post(`${API_URL}/upload-file`, file);
};

// Get list of gallery images private
export const getGalleryImagesPrivate = ({
	eventId,
	categoryId = 0,
	limit = 10,
	offset = 0
}: any) => {
	return axios.get(`${API_URL}/${EVENT}/${eventId}/gallery/media/private`, {
		params: {
			...(categoryId && { "category-id": categoryId }),
			limit,
			offset
		}
	});
};

// Get list of gallery images public
export const getGalleryImages = ({ eventId, categoryId = 0, limit = 10, offset = 0 }: any) => {
	return axios.get(`${API_URL}/${EVENT}/${eventId}/gallery/media/public`, {
		params: {
			...(categoryId && { "category-id": categoryId }),
			limit,
			offset
		}
	});
};

export const uploadFaceImageGallery = (eventId: string, request: any) => {
	return axios.post(`${API_URL}/${EVENT}/${eventId}/face-upload`, request);
};

export const searchGalleryImage = (eventId: string, fileName: string | null) => {
	const isPublicFaceSearch = PUBLIC_FACE_SEARCH_EVENTS?.includes(eventId);
	const endpointPath = isPublicFaceSearch
		? "/gallery/media/search/public"
		: "/gallery/media/search";
	return axios.post(`${API_URL}/${EVENT}/${eventId}${endpointPath}`, {
		"file-name": fileName
	});
};

// Download gallery images
export const downloadGalleryImages = (eventId = "", payload = {}) => {
	return axios.post(`${API_URL}/${EVENT}/${eventId}/gallery/media/download`, payload);
};
